import { Switch, Typography, Space } from 'antd';
import type { WidgetSettingsProps } from './types';

const { Text } = Typography;

export const AlertsWidgetSettings = ({ config, onChange }: WidgetSettingsProps) => {
  const showActive = (config.showActive as boolean) ?? true;
  const showLatest = (config.showLatest as boolean) ?? false;

  return (
    <div>
      <Text strong style={{ display: 'block', marginBottom: 12, fontSize: 13 }}>
        Display Mode
      </Text>
      <Text type="secondary" style={{ display: 'block', marginBottom: 16, fontSize: 12 }}>
        Choose which alerts to display. Both options can be combined.
      </Text>

      <Space direction="vertical" size={12}>
        <Space size={10}>
          <Switch
            checked={showActive}
            onChange={(checked) => onChange({ showActive: checked })}
          />
          <div>
            <Text style={{ fontSize: 13 }}>Active alerts</Text>
            <br />
            <Text type="secondary" style={{ fontSize: 11 }}>
              Alerts whose end time has not yet passed
            </Text>
          </div>
        </Space>

        <Space size={10}>
          <Switch
            checked={showLatest}
            onChange={(checked) => onChange({ showLatest: checked })}
          />
          <div>
            <Text style={{ fontSize: 13 }}>Latest alerts</Text>
            <br />
            <Text type="secondary" style={{ fontSize: 11 }}>
              Most recently created alerts (up to 20), including ended ones
            </Text>
          </div>
        </Space>
      </Space>
    </div>
  );
};
